<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">姓名：</div>
        <el-input
          placeholder="请输入嫌疑人姓名"
          size="medium"
          v-model="queryInfo.title"
          @change="getFacelibrary()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位人员设备卡片区域 -->
      <div class="leftBox">
        <!-- 单位人员设备树 -->

        <el-tree
          class="treeBox"
          :data="ArchInfo"
          :props="defaultTreesProps"
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="name"
          ref="navTree"
          @check-change="getCheckedDevicesNodes"
        >
          <!-- :render-content="renderContent"  -->
          <span slot-scope="{ node, data }">
            <div class="bigTree">
              <div class="leftTree">
                <div>
                  <!-- 单位图标 -->
                  <img
                    v-show="data.type == 1"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/dw.svg"
                  />
                  <!-- 人员图标 -->
                  <img
                    v-show="data.type == 2"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/ry.svg"
                  />
                  <!-- 执法仪不在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == false"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj.svg')
                        : require('../../../assets/img/tree/zngb.svg')
                    "
                  />
                  <!-- 执法仪在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == true"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy_online.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq_online.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm_online.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj_online.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj_online.svg')
                        : require('../../../assets/img/tree/zngb_online.svg')
                    "
                  />
                </div>

                <!-- 设备名称 -->
                <el-tooltip
                  v-show="data.type == 3"
                  class="item"
                  effect="dark"
                  :content="node.label"
                  placement="top"
                >
                  <div ref="nodeLabel">
                    <div v-if="node.label.length > 8">
                      {{
                        node.label.replace(
                          /(\d{3})\d*([0-9a-zA-Z]{3})/,
                          "$1***$2"
                        )
                      }}
                    </div>
                    <div v-else>
                      {{ node.label }}
                    </div>
                  </div>
                </el-tooltip>

                <!--  -->
                <!-- 单位和人员名称 -->
                <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <!-- 右边单位人员设备卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加人脸按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddFacelibraryDialogVisible = true"
          >
            新增嫌疑人脸
          </el-button>
          <!-- 增加人脸按钮 -->
          <el-button
            icon="el-icon-share"
            type="primary"
            size="small"
            class="add-btn"
            @click="sendFaceToDevices"
            v-if="sendFaceBtn"
          >
            下发人脸
          </el-button>
          <!-- 人脸信息表格区域 -->
          <el-table
            :data="FacelibraryList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            @selection-change="handleSelectionChange"
            ref="PlNumberTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="flTitle" label="姓名"> </el-table-column>
            <el-table-column prop="flTitle" width="150" label="图像">
              <template v-slot="flImgSlot">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="'data:image/png;base64,' + flImgSlot.row.flImg"
                  :preview-src-list="[
                    'data:image/png;base64,' + flImgSlot.row.flImg,
                  ]"
                >
                </el-image>
              </template>
            </el-table-column>

            <el-table-column prop="fwCreatetime" label="创建时间">
            </el-table-column>
            <el-table-column prop="flChildrenShow" label="允许下级项目查看">
              <template v-slot="fenceSlot">
                <span>{{
                  fenceSlot.row.flChildrenShow == false ? "否" : "是"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fwRemark" label="备注"> </el-table-column>

            <el-table-column label="下发设备">
              <template v-slot="slotPlId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getFlIdDevice(slotPlId.row.flId)"
                  >查看下发设备</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="openUpdatePlNumber(slot.row)"
                  ></el-button>
                </el-tooltip> -->
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteFaceByplId(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加人脸信息对话框 -->
    <el-dialog
      title="新增嫌疑人脸"
      :visible.sync="AddFacelibraryDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddPlNumberDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addFacelibraryFormRef"
        :rules="AddFlImgRules"
        :model="FacelibraryInfo"
        label-width="80px"
      >
        <el-form-item prop="title" label="姓名">
          <el-input
            placeholder="请输入姓名"
            v-model="FacelibraryInfo.title"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="remark" label="备注">
          <el-input
            placeholder="请输入备注"
            v-model="FacelibraryInfo.remark"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="允许下级项目查看">
          <el-radio-group
            v-model="FacelibraryInfo.isChildrenShow"
            style="display: flex; height: 80px; align-items: center"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="flImg" label="人脸">
          <el-upload
            class="avatar-uploader"
            action="sss"
            list-type="picture-card"
            :class="{ disabled: uploadDisabled }"
            :auto-upload="false"
            :limit="1"
            ref="upload"
            :on-change="handleChange"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-alert
            title="上传正面人脸图片只能是 JPG 、png 格式,且宽高不能超过640px,大小不能超过5M!"
            type="warning"
            center
            show-icon
          >
          </el-alert>
          <!-- 预览图片 -->
          <el-dialog :visible.sync="dialogVisibleimg" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddFacelibraryDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="AddFacelibrary()"
          :disabled="this.AddFacelibraryBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改人脸信息对话框 -->
    <el-dialog
      title="修改人脸信息"
      :visible.sync="UpdatePlNumberDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updatePlNumberFormRef"
        :rules="AddFlImgRules"
        :model="UpdateInfo"
        label-width="80px"
      >
        <el-form-item prop="title" label="车牌号">
          <el-input
            placeholder="请输入车牌号"
            v-model="UpdateInfo.title"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            placeholder="请输入备注"
            v-model="UpdateInfo.remark"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdatePlNumberDialog = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看下发人脸信息对话框 -->
    <el-dialog
      title="人脸已下发设备"
      :visible.sync="sendDevicesDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearsendDevicesDialogVisible()"
    >
      <el-table
        :data="sendDevicesList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        :default-sort="{ prop: 'devCreatetime', order: 'descending' }"
      >
        <el-table-column prop="devEmpName" label="使用人员"> </el-table-column>
        <el-table-column prop="devNo" label="设备编号"> </el-table-column>
        <el-table-column prop="devCreatetime" sortable label="下发时间">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="UnissueSlot">
            <el-button
              type="warning"
              size="small"
              @click="Unissue(UnissueSlot.row.devId)"
              >解除下发</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    // 是否添加人脸验证
    var imgValid = (rule, value, callback) => {
      // console.log("this.fileList.length", this.FacelibraryInfo.file);

      if (
        this.FacelibraryInfo.file == "" ||
        this.FacelibraryInfo.file == null
      ) {
        callback(new Error("请上传人脸图片"));
      } else {
        callback();
      }
    };
    return {
      // 人脸列表信息
      FacelibraryList: [],
      // 人脸列表查询信息
      queryInfo: {
        // 人脸姓名
        title: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //  单位总数量
      total: 0,
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 控制增加人脸对话框的显示和隐藏
      AddFacelibraryDialogVisible: false,

      //上传人脸查看人脸对话框
      dialogVisibleimg: false,
      // 上传人脸查看人脸
      dialogImageUrl: "",
      formdata: new FormData(),
      fileList: [],
      addimg: [],
      removeimg: [],

      // 控制发送人脸按钮显示与隐藏
      sendFaceBtn: false,
      // 下发人脸参数
      sendFaceToDevicesInfo: {
        devIds: [], //设备id
        flIds: [], //人脸id
      },
      // 人脸实体
      FacelibraryInfo: {
        // 姓名
        title: "",
        // 是否允许下级单位查看
        isChildrenShow: false,
        // 备注
        remark: "",
        // 人脸图片
        file: "",
      },
      // 添加人脸提交确定按钮禁用开启状态
      AddFacelibraryBtn: false,
      // 查看下发设备对话框
      sendDevicesDialog: false,
      // 人脸下发设备
      sendDevicesList: [],
      //解除人脸下发设备的人脸ID
      unissueFlId: "",
      // 控制修改对话框的显示和隐藏
      UpdatePlNumberDialog: false,
      // 修改人脸实体
      UpdateInfo: {
        // 人脸标题
        title: "",
        // 备注
        remark: "",
      },
      //增加人脸规则校验
      AddFlImgRules: {
        title: [{ required: true, message: "请输入人脸姓名", trigger: "blur" }],
        flImg: [
          {
            required: true,
            trigger: "change",
            validator: imgValid,
          },
        ],
      },
    };
  },
  computed: {
    uploadDisabled: function () {
      // console.log(this.FacelibraryInfo.file);
      return this.FacelibraryInfo.file != "";
    },
  },
  created() {
    // 获取人脸列表信息
    this.getFacelibrary();
    // 获取单位人员设备树
    this.getDepPersonDevTree();
  },
  mounted() {},
  methods: {
    // 查询人脸列表信息
    async getFacelibrary() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/facelibrary/search`,
        {
          params: this.queryInfo,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.FacelibraryList = res.data.rows;
      // 人脸总数量
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getFacelibrary();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getFacelibrary();
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes() {
      var devices = this.$refs.navTree.getCheckedNodes();
      var devIds = [];
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.type == 3) {
          devIds.push(element.id);
        }
      }
      this.sendFaceToDevicesInfo.devIds = devIds;
    },
    // 获取table选中的人脸信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendFaceBtn = true;
        var flIds = [];
        for (let i = 0; i < val.length; i++) {
          flIds.push(val[i].flId);
        }
        this.sendFaceToDevicesInfo.flIds = flIds;
      } else {
        this.sendFaceBtn = false;
      }
    },
    // 人脸下发
    async sendFaceToDevices() {
      if (this.sendFaceToDevicesInfo.devIds.length == 0) {
        return this.$message.warning("请选择要下发的设备!");
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/facelibrary/send`,
        this.sendFaceToDevicesInfo
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 清空树的选中
      this.$refs.navTree.setCheckedNodes([]);
      // 清空表格选中
      this.$refs.PlNumberTable.clearSelection();
      this.$message.success("人脸下发成功");
    },

    // 根据人脸查看对应下发的设备
    async getFlIdDevice(flId) {
      this.unissueFlId = flId;
      const { data: res } = await this.$axios.get(
        `${this.$api}/facelibrary/getFlIdDevice`,
        {
          params: { flId: flId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesDialog = true;
      if (res.data.rows !== null && res.data.rows !== "") {
        this.sendDevicesList = res.data.rows;
      }
    },

    // 关闭人脸查看对应下发的设备对话框
    clearsendDevicesDialogVisible() {
      this.sendDevicesList = [];
    },
    // 解除设备下发人脸
    async Unissue(devId) {
      const confirmVal = await this.$confirm(
        "此操作将会解除此设备的人脸下发, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/facelibrary/unissue`,
        {
          params: { devId: devId, flId: this.unissueFlId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesList = [];
      this.getFlIdDevice(this.unissueFlId);
    },
    // 增加人脸
    AddFacelibrary() {
      // 人脸提交确定按钮禁用
      this.AddFacelibraryBtn = true;
      this.$refs.addFacelibraryFormRef.validate(async (valid) => {
        if (!valid) {
          this.AddFacelibraryBtn = false;
          return;
        }
        this.formdata = new FormData();
        //新增
        this.formdata.append("file", this.FacelibraryInfo.file); //上传图片要把参数和值放在FormData里
        this.formdata.append(
          "isChildrenShow",
          this.FacelibraryInfo.isChildrenShow
        ); //是否允许下级单位查看
        this.formdata.append("title", this.FacelibraryInfo.title); //上传图片要把参数和值放在FormData里
        this.formdata.append("remark", this.FacelibraryInfo.remark); //上传图片要把参数和值放在FormData里
        //如果有其他参数，也要一并放在this.formdata里
        /* 例：
	            this.formdata.append("csLevel", his.FacelibraryInfo.serviceLevel);
          		this.formdata.append("csMaximum", his.FacelibraryInfo.size);
          		*/

        const { data: res } = await this.$axios.post(
          `${this.$api}/facelibrary/add`,
          this.formdata
        );
        if (res.status != 0) {
          this.AddFacelibraryBtn = false;
          return this.$message.error(res.msg);
        }
        // 人脸提交确定按钮开启
        this.AddFacelibraryBtn = false;
        this.$message.success("新增人脸成功");
        this.AddFacelibraryDialogVisible = false;
        this.getFacelibrary();
      });
    },

    // 添加人脸图片
    handleChange(file, fileList) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传人脸图片只能是 JPG 、png 格式!");
        fileList.splice(-1, 1); //移除错误文件
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
        fileList.splice(-1, 1);
        return false;
      }

      let img = new Image();
      img.src = file.url;
      let _this = this;
      img.onload = (e) => {
        let imgWidth = img.width;
        let imgHeight = img.height;
        if (imgWidth > 640 || imgHeight > 640) {
          _this.$message.error("上传人脸图片宽高不能超过  640px!");
          fileList.splice(-1, 1); //移除错误文件
          return false;
        } else {
          this.addimg = fileList[0].raw;
          this.FacelibraryInfo.file = this.addimg;
        }
      };
      // this.addimg = fileList[0].raw;
      // this.FacelibraryInfo.file = this.addimg;
    },
    // 删除活动展示照片
    handleRemove(file, fileList) {
      this.FacelibraryInfo.file = "";
      this.formdata = new FormData();
    },
    // 活动展示照片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleimg = true;
    },
    // 渲染编辑获取id
    apply() {
      this.fileList = [{ url: "" }]; //这里是踩坑的点，必须写
      this.fileList[0].url = res.data.flImg; //这里是调用接口获取到的值 res.data.flImg，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },

    //关闭增加人脸信息
    clearAddPlNumberDialogVisible() {
      this.$refs.addFacelibraryFormRef.resetFields();

      // 人脸实体
      this.FacelibraryInfo = {
        // 姓名
        title: "",
        // 备注
        remark: "",
        // 是否允许查看下级单位数据
        isChildrenShow: false,
        // 人脸图片
        file: "",
      };
      this.fileList = [];
    },
    //打开修改人脸信息对话框
    openUpdatePlNumber(vule) {
      this.UpdatePlNumberDialog = true;
      // 车牌ID
      this.UpdateInfo.plId = vule.plId;
      // 车牌号
      this.UpdateInfo.title = vule.plNumber;
      // 备注
      this.UpdateInfo.remark = vule.remark;
    },

    // 修改人脸信息
    async Update() {
      this.$refs.updatePlNumberFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/platelibrary/modify/${this.UpdateInfo.plId}`,
          {
            // 人脸姓名
            title: this.UpdateInfo.plNumber,
            // 备注
            remark: this.UpdateInfo.remark,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("修改人脸信息成功");
        this.getFacelibrary();
        this.UpdatePlNumberDialog = false;
      });
    },

    //关闭修改人脸信息对话框
    clearUpdateDialogVisible() {
      this.$refs.updatePlNumberFormRef.resetFields();
    },
    // 删除人脸
    async deleteFaceByplId(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该人脸信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/facelibrary/delete/` + value.flId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("人脸信息删除成功");
      this.getFacelibrary();
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 260px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}

// 图片上传样式
/deep/.disabled {
  .el-upload--picture-card {
    display: none;
  }
}

// Alert 警告
.el-alert {
  margin-top: 10px;
  padding: 0;
  // height: 30px;
}

// 单选按钮
.el-radio {
  color: #90caca;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/IntelligentAI/faceDatabase.vue